<!-- Data table -->
<div class="clearfix"></div>
<div class="mt-lg-3">
  <nz-table
    [nzData]="reportItems"
    [nzShowPagination]="false"
    [nzBordered]="true"
    [nzScroll]="{ y: maxBodyTableHeight, x: '1600px' }"
    [nzNoResult]=noResult
    [nzLoading]="isLoading">
    <thead>
    <tr>
      <th scope="col" nzWidth="200px">{{ getRCALabel() }}</th>
      <th scope="col" nzWidth="200px">Tagname</th>
      <th scope="col">Title</th>
      <th scope="col" nzWidth="160px"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let reportItem of reportItems">
      <td class="">
        <a
          class="btn btn-link p-0 m-0"
          [routerLink]="[reportItem.tag, reportItem.no]"
          [queryParams]=getBackRefParam()
          [title]="reportItem.no">
          {{ reportItem.no }}
        </a>
      </td>
      <td>{{ reportItem.tag }}</td>
      <td>{{ reportItem.title }}</td>
      <td class="text-center">
        <ng-container *ngIf="!reportItem.active;">
          <button
            [disabled]="isLoading || disableReactivateRCA"
            class="btn btn-outline-success btn-sm"
            type="button"
            nz-popconfirm=""
            nzOkText="Yes"
            (nzOnConfirm)="onOpenRCA(reportItem)"
            nzPopconfirmTitle="Do you want to reactivate this RCA?"
            nzPopconfirmPlacement="bottom">Reactivate RCA</button>
        </ng-container>
      </td>
    </tr>
    </tbody>
  </nz-table>

  <ng-container *ngIf="reportItems.length > 0">
    <!-- Pagination -->
    <div class="centered-pagination text-center mt-3">
      <ngb-pagination
        [collectionSize]="collectionSize"
        [page]="page"
        [pageSize]="pageSize"
        [directionLinks]="true"
        [rotate]="true"
        [disabled]="isLoading"
        [maxSize]="10"
        (pageChange)="onPageChanged($event)"></ngb-pagination>

      <app-pagination-size
        [currentSize]="pageSize"
        [currentPage]="page"
        [total]="collectionSize"
        (sizeChangeEvent)="onPageSizeChanged($event)"></app-pagination-size>
    </div>
  </ng-container>
</div>

<ng-template #noResult>
  <div class="mt-3 mb-3">
    <nz-alert nzType="info" nzMessage="No data available!" nzCloseable="true"></nz-alert>
  </div>
</ng-template>
